<template>
    <DetailComponent
        :breadcrumb="breadcrumb"
        :rest_api="rest_api"
        :parent_id="parent_id"
        :rest_api_note="rest_api_note"
        :title_page="title_page"
        :single_object="single_object"
        :array_options="array_options"
        :form_format="form_format"
        :notes="single_object.notes"
        :back_href="'/qc-surveys'"
    />    
</template>
<script>

import FormResources    from    './form_resources'
import Resources        from    './resources'
import DetailComponent  from    '@/components/DetailComponent/DetailComponent'
import { Notyf }        from    'notyf';
import 'vuetify/dist/vuetify.min.css'
import 'notyf/notyf.min.css'; // for React and Vue
const notyf = new Notyf({
    duration: 8000,
});

export default {
    name: 'SurveyDetail',
    components: {
        DetailComponent
    },
    
    data(){
        return{
            notyf,
            parent_id:          this.$route.params.id,
            rest_api:           `surveys/${this.$route.params.id}`,
            lite_rest_api:      `surveys`,
            rest_api_note:      `survey_notes`,
            form_format:        FormResources.form_format,
            breadcrumb:         Resources.breadcrumb,
            title_page:         '',
            content_header:     this.$store.state.headers,
            single_object:      {},
            array_options:      {},
        }
    },

    methods:{

        fill_data(data) {
            this.single_object  = data.parent;
            this.array_options = {
                room_type_id: data.room_types,
                inspection_type_id: data.inspection_types
            }
            this.title_page     = this.single_object.name;
            this.breadcrumb[1].arrow = "<span class='slash'>/</span>"
            this.breadcrumb.push({
                name:   this.single_object.name,
                href:   '#',
                arrow:  " ",
            });
        },

    },

    async mounted(){
        await this.api_request(this.rest_api);
    }
}
</script>